export default function ($sceDelegateProvider, $compileProvider) {
  'ngInject';

  $compileProvider.debugInfoEnabled(true);

  let resources = process.env.RESOURCE_URL_WHITELIST.split(',');
  $sceDelegateProvider.resourceUrlWhitelist(resources);
}
